module.exports = __webpack_public_path__ + "img/maket_atlas_-4de6f6096e2227f491607fa4989a4d6c.png";


//////////////////
// WEBPACK FOOTER
// ./temp/img/maket_atlas_.png
// module id = 368
// module chunks = 0